import * as validationUtil from '../common/util/validation-util';

export default angular.module('app.validation-directives', [])
.directive('aspectRatioValidator', function() {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$validators.aspectRatio = function(modelValue, viewValue) {
        //if (ctrl.$isEmpty(modelValue)) { return true; }
        return validationUtil.matchesAspectRatio(viewValue);
      };
    }
  };
})
.directive('maxLengthValidator', function() {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$validators.maxLength = function(modelValue, viewValue) {
        if (attrs.allowEmpty && (modelValue === null || modelValue === undefined)) { return true; }
        return validationUtil.isShorterThenMaxLength(viewValue, attrs.maxLength);
      };
    }
  };
})
.directive('numberBetweenValidator', function() {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$validators.numberBetween = function(modelValue, viewValue) {
        if (attrs.allowEmpty && (modelValue === null || modelValue === undefined)) { return true; }
        else { return validationUtil.numberBetween(parseFloat(viewValue), parseFloat(attrs.minValue), parseFloat(attrs.maxValue)); }
      };
    }
  };
})
.directive('isIntegerValidator', function() {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$validators.isInteger = function(modelValue, viewValue) {
        if (attrs.allowEmpty && (modelValue === null || modelValue === undefined)) { return true; }
        else { return validationUtil.isInteger(modelValue); }
      };
    }
  };
})
.directive('filePresentValidator', function() {
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl) {
      ctrl.$validators.filePresent = function(modelValue, viewValue) {
        return modelValue !== null && modelValue !== undefined;
      };
    }
  };
});



/** WEBPACK FOOTER **
 ** ./src/directives/validationDirectives.js
 **/